/** All available project status types */
export enum ProjectStatusTypeEnum {
  /** New project */
  NEW = 'NEW',
  /** Project in progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Project on review */
  REVIEW = 'REVIEW',
  /** Project done */
  DONE = 'DONE',
  /** Project cancelled */
  CANCELED = 'CANCELED',
  /** Project paused */
  PAUSED = 'PAUSED',
  /** Project is "theme" (directory for other projects) */
  THEME = 'THEME'
}
